let logrocketInstance: any = null;

export async function initLogRocket(): Promise<any> {
  if (logrocketInstance) {
    return logrocketInstance;
  }

  if (import.meta.env.PROD && import.meta.env.VITE_LOGROCKET_PROJECT_ID) {
    const LogRocket = await import('logrocket');
    logrocketInstance = LogRocket.default;
    logrocketInstance.init(import.meta.env.VITE_LOGROCKET_PROJECT_ID);
  }

  return logrocketInstance;
}

export function identifyUser(userId: string | number, traits: Record<string, any> = {}): void {
  if (logrocketInstance) {
    logrocketInstance.identify(String(userId), traits);
  }
}

export function getLogRocketInstance(): any {
  return logrocketInstance;
}

export function trackFeedbackSubmission(feedbackData: any): void {
  if (!logrocketInstance) return;

  try {
    logrocketInstance.track('Feedback Submitted', {
      feedbackId: String(feedbackData.feedbackId),
      type: feedbackData.type,
      route: feedbackData.route || null,
    });
    console.log('✓ LogRocket: Tracked feedback submission', feedbackData.feedbackId);
  } catch (error) {
    console.warn('✗ LogRocket: Failed to track feedback', error);
  }
}
